import React, { PureComponent } from 'react';
import { IMAGES_REPO } from '../../../config';

export default class SectionTypeText extends PureComponent {

  render() {
    const { body, photo1, photo2, photo3 } = this.props;
    return (
      <div className="more-about-us">
        <div className="more-about-us__images">
          {photo3 && <img className="img" src={`${IMAGES_REPO}${photo3}`}/>}
          {photo2 && <img className="img" src={`${IMAGES_REPO}${photo2}`}/>}
          {photo1 && <img className="img" src={`${IMAGES_REPO}${photo1}`}/>}
        </div>
        <div dangerouslySetInnerHTML={{ __html: body }}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/type-of-sections/text/index.js